"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jumpScheme = void 0;
var web_base_1 = require("@tencent/web-base");
var weixin_launch_1 = require("./weixin-launch");
/**
 * 适配微信 & 企业微信特邀二维码唤起的scheme跳转
 * @param schemeUrl
 * @param {ReportCallback} reportCallback 灯塔上报回调
 * @param {WxLaunchFailedCallback} wxLaunchFailedCallback 微信唤起失败回调函数
 */
var jumpScheme = function (schemeUrl, debugMode, jumpCallback, reportCallback) {
    if (debugMode === void 0) { debugMode = false; }
    if (reportCallback) {
        reportCallback('web_jump_scheme');
    }
    // 如果微信小于4.0.1194.400版本，返回引导提示
    var $isWeiXinQBCoreLt = (0, web_base_1.isWeiXinQBCoreLt)('4.0.1194.400');
    if ($isWeiXinQBCoreLt) {
        return {
            msg: {
                title: '提示',
                content: '当前微信版本较低，您可以在浏览器工具栏上选择“复制链接”或“浏览器打开”',
            },
        };
    }
    var useWeixinJSBridge = (0, web_base_1.isWeiXinGte656)() && !(0, web_base_1.isWindowsWechat)() && !(0, web_base_1.isMacWechat)();
    // 企业微信：找微信同事，launchApplication 打开第三方 app
    if (useWeixinJSBridge) {
        console.log('>>> window.WeixinJSBridge:', window.WeixinJSBridge);
        if (window.WeixinJSBridge) {
            (0, weixin_launch_1.doWeiXinLaunch)(schemeUrl, debugMode, reportCallback, jumpCallback);
        }
        else {
            console.log('WeixinJSBridge not ready yet.');
            if (reportCallback) {
                reportCallback('web_wxjsbridge_not_ready_yet');
            }
            document.addEventListener('WeixinJSBridgeReady', function () {
                // 此时立即调用权限可能还未准备好，所以doLaunch里需要延迟调用
                (0, weixin_launch_1.doWeiXinLaunch)(schemeUrl, debugMode, reportCallback, jumpCallback);
            });
        }
    }
    else {
        var isSafariMAC = (0, web_base_1.isSafari)() && !(0, web_base_1.isMobile)();
        var useIframe = isSafariMAC || (0, web_base_1.isEdge)() || (0, web_base_1.isIE)() || (0, web_base_1.isFF)();
        // 这里为什么要useIframe呢？？？
        if (useIframe) {
            var el_1 = document.createElement('iframe');
            el_1.style.display = 'none';
            el_1.src = schemeUrl;
            document.body.appendChild(el_1);
            setTimeout(function () {
                document.body.removeChild(el_1);
            }, 3000);
            // one more thing
            if (isSafariMAC && navigator && navigator.maxTouchPoints) {
                window.location.href = schemeUrl;
            }
        }
        else {
            window.location.href = schemeUrl;
        }
    }
};
exports.jumpScheme = jumpScheme;
//# sourceMappingURL=jump-scheme.js.map